import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

interface UserData {
    token: string;
}

const useAuthHeaders = () => {
    const auth = useAuthUser<UserData>();

    const token = auth?.token;

    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
    }
}

export default useAuthHeaders;
